import { render, staticRenderFns } from "./UseRedesignNavItem.vue?vue&type=template&id=4b7b6394&"
import script from "./UseRedesignNavItem.vue?vue&type=script&lang=js&"
export * from "./UseRedesignNavItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports